// extracted by mini-css-extract-plugin
export var container = "Logos-module--container--AE1HZ";
export var container__item = "Logos-module--container__item--LH1Ef";